const base =
  "https://delivery.localazy.com/_a7379281332786823710e1352a7d/_e0/938eba638cb4a6738db5b7556da7fe4d1852c641"
const metric =
  "https://delivery.localazy.com/_a7379281332786823710e1352a7d/_e0/2df52fa1e4e153087359b73014c0c562e319be56"
const rules =
  "https://delivery.localazy.com/_a7379281332786823710e1352a7d/_e0/cb894753d361cffd0d2f542fa4da2b7921ec58bd"
const messages =
  "https://delivery.localazy.com/_a7379281332786823710e1352a7d/_e0/458f5abfa52d23ba6d6c156d2370a20f6f4b09fb"
const button =
  "https://delivery.localazy.com/_a7379281332786823710e1352a7d/_e0/4a31f6abf33a32731f51f001872f9c208c5c7971"

export const fileCDNUrls = {
  base,
  metric,
  rules,
  messages,
  button,
}

const getLocale = (lang: string) => {
  switch (lang) {
    case "zh":
      return "zh-Hant"
    default:
      return lang
  }
}

export const getLang = async (lang: string) => {
  const result: Record<string, Record<string, string>> = {}

  const promises = Object.entries(fileCDNUrls).map(async ([key, url]) => {
    try {
      const response = await fetch(`${url}/${getLocale(lang)}/${key}.json`)

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`)
      }

      result[key] = await response.json()
    } catch (error) {
      console.error(`Failed to fetch ${key} language file:`, error)
      throw error
    }
  })

  await Promise.all(promises)

  return result
}
